import React, { useEffect, useRef } from "react";
import Column3D from "./NormalColumns/Column3D";
import MastColumnBeam from "./MastColumns/mastColumnBeam";
import MastColumnNone from "./MastColumns/mastColumnNone";
import MastWallBeam from "./MastWalls/mastWallBeam";
import MastWallNone from "./MastWalls/mastWallNone";

const Mast3D = ({ column, colorList, luminaires, gridScaleX, gridScaleY }) => {
    const groupRef = useRef();

    useEffect(() => {
        if (!groupRef.current) return;

        groupRef.current.traverse((child) => {
            child.renderOrder = 900;

            if (child.material) {
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach((material) => {
                    if (!material) return;
                    material.transparent = true;
                    material.opacity = material.opacity ?? 1;
                    material.depthTest = true;
                    material.depthWrite = true;
                    material.needsUpdate = true;
                });
            }
        });
    }, [column]);

    return (
        <group ref={groupRef}>
            {(column.isMast === false || column.isMast === undefined) && (
                <Column3D
                    column={column}
                    gridScaleX={gridScaleX}
                    gridScaleY={gridScaleY}
                />
            )}

            {/* {column.isMast == true && column.values.mountingType === "wall" && (
                <>
                    {column.values.configuration == "None" && (
                        <MastWallNone
                            column={column}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}

                    {(column.values.configuration == "Beam Aiming" || column.values.configuration == "Asymmetrical Flood Aiming") && (
                        <MastWallBeam
                            column={column}
                            colorList={colorList}
                            luminaires={luminaires}
                        />
                    )}

                </>
            )} */}

            {column.isMast == true && column.values.mountingType === "column" && (
                <>
                    {column.values.configuration == "None" && (
                        <MastColumnNone
                            column={column}
                            colorList={colorList}
                            luminaires={luminaires}
                            gridScaleX={gridScaleX}
                            gridScaleY={gridScaleY}
                        />
                    )}

                    {(column.values.configuration == "Beam Aiming" || column.values.configuration == "Asymmetrical Flood Aiming") && (
                        <MastColumnBeam
                            column={column}
                            colorList={colorList}
                            luminaires={luminaires}
                            gridScaleX={gridScaleX}
                            gridScaleY={gridScaleY}
                        />
                    )}
                </>
            )}
        </group>
    );
};

export default Mast3D;
